module.exports = __webpack_public_path__ + "static/media/laptop.e75679ff.svg";